export default __webpack_public_path__ + "static/media/white-logo.0f985066.svg";